import React from 'react';

import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import hasDownstreamFlagRowsStep from 'pipelines/hasDownstreamFlagRowsStep';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';
import {InlineBannerProps, InlineBannerType} from 'ui-library/banners/InlineBanner';
import InlineBannerStack from 'ui-library/banners/InlineBannerStack';

const LOCK_MESSAGE = 'This table is locked. One or more downstream views contain flagged rows.';

export interface StepLockedWarningBannerProps {
  analysis: PipelineGraphQL;
  step: GetAnalysisPipelineStep;
}

/**
 * Banner to alert the user when a data frame has more rows or columns than are currently being displayed.
 *
 * If the entire data frame is available, will return null.
 */
export default function StepLockedWarningBanner({
  analysis,
  step,
}: StepLockedWarningBannerProps): JSX.Element | null {
  const messages: Array<InlineBannerProps> = [];
  if (hasDownstreamFlagRowsStep(analysis, step)) {
    messages.push({
      icon: 'lock',
      bannerType: InlineBannerType.ATTENTION,
      text: LOCK_MESSAGE,
    });
  }

  return messages.length > 0 ? <InlineBannerStack messages={messages} /> : null;
}
